import * as React from "react";
import { useRef, useState } from "react";
import ColorLens from "@mui/icons-material/ColorLens";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const VinylCombobox = ({ errorText, label, onSelect, options }) => {
  const inputLabel = useRef(null);

  const [inputValue, setInputValue] = useState("");

  const handleComboboxSelect = event => {
    onSelect(event.target.value);
    setInputValue(event.target.value);
  };

  return (
    <FormControl fullWidth error={errorText.length > 0}>
      <InputLabel ref={inputLabel}>{label}</InputLabel>
      <Select
        labelid="vinyl-size-select"
        id="vinyl-size-select"
        value={inputValue}
        onChange={handleComboboxSelect}
      >
        {options &&
          options.map(option => (
            <MenuItem key={option.id} value={option.value}>
              {option.color && (
                <ColorLens
                  style={{
                    fill: option.color ? option.color.formatted : "fff",
                    marginRight: 8
                  }}
                />
              )}
              {option.label}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>{errorText.join(", ")}</FormHelperText>
    </FormControl>
  );
};

export default VinylCombobox;
